<template>
    <div class="login">
      <!--ログインコンポーネント-->
      <amplify-authenticator>
          <amplify-sign-out></amplify-sign-out>
      </amplify-authenticator>
    </div>
</template>

<script>
export default {
  name: 'Delete',
  mounted() {
    // Footer表示フラグ更新
    this.$store.commit('setFooterDisplayFlag');
  },
};
</script>
